import { observer } from "mobx-react"
import { Col, Form, FormInstance, Input, Row, Select } from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"

import { urlPattern } from "@src/app/validators"
import {
  CreateRequest,
  DomainsCollection,
} from "@src/pages/settingsDomain/classes/DomainsCollection"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"

type Props = WithCollection<DomainsCollection> & {
  form: FormInstance
}
export const DomainForm = observer(({ collection, form }: Props) => {
  const onsubmit = async (data: CreateRequest) => {
    await collection.create(data)
    form.resetFields()
  }

  return (
    <Form
      form={form}
      id="GENERATED_ID_DOMAINFORM_FORM_VOID_1"
      layout="vertical"
      name="whitelistDomain"
      onFinish={onsubmit}
      size="large"
    >
      <Row align="top" gutter={16}>
        <Col span={10}>
          <Form.Item
            id="GENERATED_ID_DOMAINFORM_TSX_FORM.ITEM_VOID_1"
            label="Project Name"
            name="project_id"
            rules={[{ message: "Please select at least one", required: true }]}
          >
            <Select
              loading={collection.projects.isLoading}
              options={collection.projects.selectOptions}
              placeholder="Select project"
            />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item
            id="GENERATED_ID_DOMAINFORM_TSX_FORM.ITEM_VOID_2"
            label="Domain"
            name="url"
            rules={[
              {
                message: "Please, input correct url",
                pattern: urlPattern,
                required: true,
              },
            ]}
          >
            <Input placeholder="https://mydomain.shop" />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            id="GENERATED_ID_DOMAINFORM_TSX_FORM.ITEM_VOID_3"
            label={" "}
          >
            <SubmitButton
              buttonProps={{
                icon: <PlusCircleOutlined />,
                loading: collection.isLoading,
                size: "large",
                type: "primary",
              }}
              form={form}
            >
              Add Domain
            </SubmitButton>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
})
